var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvent12Ziekenhuis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 184.62 107.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-5 {\n        fill: #ffd45b;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-7 {\n        fill: #dbdbdb;\n      }\n\n      .cls-8 {\n        fill: #37474f;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-11 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-11, .cls-12 {\n        fill: none;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-16 {\n        fill: #455a64;\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-23 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-25 {\n        fill: #a6a6a6;\n      }\n\n      .cls-26, .cls-27 {\n        isolation: isolate;\n      }\n\n      .cls-28 {\n        fill: #cadce6;\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-29, .cls-30, .cls-31 {\n        opacity: .52;\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-35 {\n        fill: #f3f0e2;\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-38 {\n        fill: #c7c7c7;\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-42 {\n        fill: #e7e7e7;\n      }\n\n      .cls-43 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-47 {\n        opacity: .66;\n      }\n\n      .cls-47, .cls-48 {\n        fill: #718995;\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-56 {\n        opacity: .1;\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-59 {\n        fill: #ebebeb;\n      }\n\n      .cls-60, .cls-27 {\n        opacity: .1;\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-62 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-73 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-77 {\n        fill: #263238;\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-79 {\n        fill: #bd4f5c;\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-81 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-85 {\n        fill: url(#linear-gradient-26);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    width: 184.62,
    height: 107.84
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 89.52,
    cy: 98.79,
    fx: 89.52,
    fy: 98.79,
    r: 101.53,
    gradientTransform: "translate(2.3 188.15) rotate(-89.89) scale(1 .88)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#51a1e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7db9ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b5d7f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#ddecf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#f5fafd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 79.6,
    y1: 100.36,
    x2: 79.6,
    y2: 40.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a9c4c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#c3d6d4",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#d9e5e4",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 27.57,
    y1: 81.62,
    x2: 59.49,
    y2: 81.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffaea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 26.75,
    y1: 74.85,
    x2: 60.31,
    y2: 74.85,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 26.75,
    y1: 69.55,
    x2: 60.31,
    y2: 69.55,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 72.2,
    y2: 72.2,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 26.75,
    y1: 62.92,
    x2: 60.31,
    y2: 62.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 26.75,
    y1: 99.82,
    x2: 60.31,
    y2: 99.82,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 43.53,
    y1: 102.68,
    x2: 43.53,
    y2: 50.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 125.61,
    y1: 73.52,
    x2: 161.43,
    y2: 73.52,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 124.95,
    y1: 76.33,
    x2: 162.09,
    y2: 76.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4d9c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4d9c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    y1: 70.84,
    y2: 70.84,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 125.61,
    y1: 73.59,
    x2: 161.43,
    y2: 73.59,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    y1: 53.53,
    y2: 53.53,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 46.2,
    y2: 46.2,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    y1: 99.8,
    y2: 99.8,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 129.34,
    y1: 61.36,
    x2: 135.96,
    y2: 61.36,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 129.88,
    y1: 60.15,
    x2: 135.43,
    y2: 60.15,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 132.09,
    y1: 64.23,
    x2: 135.43,
    y2: 64.23,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 130.94,
    y1: 63.65,
    x2: 135.43,
    y2: 63.65,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 129.88,
    y1: 58.56,
    x2: 133.33,
    y2: 58.56,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 129.88,
    y1: 59.7,
    x2: 135.43,
    y2: 59.7,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 140.21,
    y1: 61.36,
    x2: 146.83,
    y2: 61.36,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 140.75,
    y1: 60.15,
    x2: 146.29,
    y2: 60.15,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 142.96,
    y1: 64.23,
    x2: 146.29,
    y2: 64.23,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 141.81,
    y1: 63.65,
    x2: 146.29,
    y2: 63.65,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 140.75,
    y1: 58.56,
    x2: 144.2,
    y2: 58.56,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 140.75,
    y1: 59.7,
    x2: 146.29,
    y2: 59.7,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 151.08,
    y1: 61.36,
    x2: 157.7,
    y2: 61.36,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 151.62,
    y1: 60.15,
    x2: 157.16,
    y2: 60.15,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 153.83,
    y1: 64.23,
    x2: 157.16,
    y2: 64.23,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 152.68,
    y1: 63.65,
    x2: 157.16,
    y2: 63.65,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 151.62,
    y1: 58.56,
    x2: 155.07,
    y2: 58.56,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 151.62,
    y1: 59.7,
    x2: 157.16,
    y2: 59.7,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 129.34,
    y1: 49.91,
    x2: 135.96,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 131.29,
    y1: 49.91,
    x2: 135.43,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 129.88,
    y1: 49.91,
    x2: 133.33,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 140.21,
    y1: 49.91,
    x2: 146.83,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 142.16,
    y1: 49.91,
    x2: 146.29,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 140.75,
    y1: 49.91,
    x2: 144.2,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 151.08,
    y1: 49.91,
    x2: 157.7,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 153.03,
    y1: 49.91,
    x2: 157.16,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 151.62,
    y1: 49.91,
    x2: 155.07,
    y2: 49.91,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 150.99,
    y1: 90.65,
    x2: 159.27,
    y2: 90.65,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 154.97,
    y1: 96.66,
    x2: 158.04,
    y2: 96.66,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 152.22,
    y1: 85.61,
    x2: 158.04,
    y2: 85.61,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 152.22,
    y1: 87.51,
    x2: 158.04,
    y2: 87.51,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 152.22,
    y1: 93.9,
    x2: 158.04,
    y2: 93.9,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 152.22,
    y1: 83.05,
    x2: 153.83,
    y2: 83.05,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 152.22,
    y1: 91.93,
    x2: 158.04,
    y2: 91.93,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 127.78,
    y1: 88.78,
    x2: 148.33,
    y2: 88.78,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 150.85,
    y1: 85.93,
    x2: 151.12,
    y2: 85.93,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 159.12,
    y1: 85.93,
    x2: 159.39,
    y2: 85.93,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 142.15,
    y1: 93.23,
    x2: 147.82,
    y2: 93.23,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 128.29,
    y1: 87.22,
    x2: 139.71,
    y2: 87.22,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 128.29,
    y1: 88.08,
    x2: 141.43,
    y2: 88.08,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 137.72,
    y1: 91.02,
    x2: 147.82,
    y2: 91.02,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 145.95,
    y1: 95.13,
    x2: 147.82,
    y2: 95.13,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 128.29,
    y1: 84.65,
    x2: 134.57,
    y2: 84.65,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 143.52,
    y1: 103.72,
    x2: 143.52,
    y2: 28.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 52.85,
    y: 82.46,
    width: 27.37,
    height: 23.23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 103.39,
    y: 82.46,
    width: 27.37,
    height: 23.23
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 52.85,
    y: 76.35,
    width: 77.91,
    height: 4.34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    y: -19.32,
    width: 184.62,
    height: 119.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m72.4,31.2h-34.06s1.69-2.09,3.56-2.33c0,0,3.63-10.15,9.71-10.22,5.65-.07,7.92,6.26,7.92,6.26,0,0,2.62-2.83,5.12-1.54s3.92,5,3.92,5c0,0,2.83,1.4,3.84,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m162.15,48.71h-24.18s1.2-1.64,2.52-1.83c0,0,2.58-7.97,6.89-8.03,4.01-.06,5.62,4.91,5.62,4.91,0,0,1.86-2.22,3.63-1.21s2.78,3.93,2.78,3.93c0,0,2.01,1.1,2.73,2.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m156.73,31.56h-40.95s2.04-2.51,4.27-2.8c0,0,4.37-12.2,11.67-12.28,6.8-.09,9.52,7.52,9.52,7.52,0,0,3.15-3.4,6.16-1.85,3.01,1.55,4.71,6.02,4.71,6.02,0,0,3.4,1.68,4.62,3.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m63.19,28.63h25.07s-1.24-1.52-2.62-1.71c0,0-2.67-7.46-7.14-7.51-4.16-.05-5.82,4.59-5.82,4.59,0,0-1.92-2.09-3.76-1.13s-2.88,3.67-2.88,3.67c0,0-2.07,1.04-2.84,2.09Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-83"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 125.05,
    y: 57.27,
    width: 14.46,
    height: 42.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 127.11,
    y: 53.63,
    width: 12.4,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 126.64,
    y: 59.16,
    width: 11.29,
    height: 40.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 63.08,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 67.09,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 71.1,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 75.11,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 79.13,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 83.14,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 87.15,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 91.16,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 95.18,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 126.64,
    y: 99.19,
    width: 11.29,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 139.51,
    y: 57.27,
    width: 9.06,
    height: 42.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 139.51,
    y: 53.63,
    width: 7.7,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 140.76,
    y: 59.16,
    width: 6.96,
    height: 40.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 63.08,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 67.09,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 71.1,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 75.11,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 79.13,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 83.14,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 87.15,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 91.16,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 95.18,
    width: 6.96,
    height: 0.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.76,
    y: 99.19,
    width: 6.96,
    height: 0.97
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 10.65,
    y: 75.05,
    width: 11.18,
    height: 25.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.4,
    y: 77.22,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.4,
    y: 80.51,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.4,
    y: 83.79,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.4,
    y: 87.08,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.4,
    y: 90.36,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.4,
    y: 93.65,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 12.4,
    y: 96.93,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.25,
    y: 77.22,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.25,
    y: 80.51,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.25,
    y: 83.79,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.25,
    y: 87.08,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.25,
    y: 90.36,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.25,
    y: 93.65,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 15.25,
    y: 96.93,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.09,
    y: 77.22,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.09,
    y: 80.51,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.09,
    y: 83.79,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.09,
    y: 87.08,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.09,
    y: 90.36,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.09,
    y: 93.65,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 18.09,
    y: 96.93,
    width: 1.98,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 21.82,
    y: 75.05,
    width: 7.84,
    height: 25.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 27.25,
    y: 96.69,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 27.25,
    y: 93.4,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 27.25,
    y: 90.12,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 27.25,
    y: 86.83,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 27.25,
    y: 83.55,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 27.25,
    y: 80.26,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 27.25,
    y: 76.98,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 24.93,
    y: 96.69,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 24.93,
    y: 93.4,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 24.93,
    y: 90.12,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 24.93,
    y: 86.83,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 24.93,
    y: 83.55,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 24.93,
    y: 80.26,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 24.93,
    y: 76.98,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 22.62,
    y: 96.69,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 22.62,
    y: 93.4,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 22.62,
    y: 90.12,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 22.62,
    y: 86.83,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 22.62,
    y: 83.55,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 22.62,
    y: 80.26,
    width: 1.61,
    height: 1.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 22.62,
    y: 76.98,
    width: 1.61,
    height: 1.54
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 91.25,
    y: 70.58,
    width: 14.73,
    height: 29.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 93.57,
    y: 73.15,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 93.57,
    y: 77.01,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 93.57,
    y: 80.89,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 93.57,
    y: 84.75,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 93.57,
    y: 88.62,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 93.57,
    y: 92.49,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 93.57,
    y: 96.36,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97.32,
    y: 73.15,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97.32,
    y: 77.01,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97.32,
    y: 80.89,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97.32,
    y: 84.75,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97.32,
    y: 88.62,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97.32,
    y: 92.49,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 97.32,
    y: 96.36,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.06,
    y: 73.15,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.06,
    y: 77.01,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.06,
    y: 80.89,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.06,
    y: 84.75,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.06,
    y: 88.62,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.06,
    y: 92.49,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 101.06,
    y: 96.36,
    width: 2.61,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 96.17,
    y: 67.51,
    width: 9.81,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 99.76,
    y: 65.6,
    width: 6.22,
    height: 1.91
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 105.93,
    y: 70.58,
    width: 10.33,
    height: 29.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 113.09,
    y: 96.07,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 113.09,
    y: 92.2,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 113.09,
    y: 88.33,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 113.09,
    y: 84.46,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 113.09,
    y: 80.6,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 113.09,
    y: 76.72,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 113.09,
    y: 72.86,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 110.03,
    y: 96.07,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 110.03,
    y: 92.2,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 110.03,
    y: 88.33,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 110.03,
    y: 84.46,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 110.03,
    y: 80.6,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 110.03,
    y: 76.72,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 110.03,
    y: 72.86,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 106.99,
    y: 96.07,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 106.99,
    y: 92.2,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 106.99,
    y: 88.33,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 106.99,
    y: 84.46,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 106.99,
    y: 80.6,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 106.99,
    y: 76.72,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 106.99,
    y: 72.86,
    width: 2.12,
    height: 1.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 105.93,
    y: 67.51,
    width: 8.77,
    height: 3.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 105.93,
    y: 65.6,
    width: 4.75,
    height: 1.91
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 29.57,
    y: 35.82,
    width: 12.27,
    height: 64.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 37.91,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 37.91,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 42.08,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 42.08,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 46.25,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 46.25,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 50.42,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 50.42,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 54.59,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 54.59,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 58.76,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 58.76,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 62.93,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 62.93,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 67.1,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 67.1,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 71.27,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 71.27,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 75.45,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 75.45,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 79.61,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 79.61,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 83.79,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 83.79,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 87.96,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 87.96,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 31.47,
    y: 92.13,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 92.13,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 87.96,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 83.79,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 79.62,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 75.45,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 71.28,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 67.1,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 62.93,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 58.76,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 54.59,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 50.42,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 46.25,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 42.08,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 37.54,
    y: 37.91,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 34.52,
    y: 92.13,
    width: 2.39,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 41.84,
    y: 35.82,
    width: 9.68,
    height: 64.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 92.13,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 92.13,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 87.96,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 87.96,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 83.79,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 83.79,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 79.62,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 79.62,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 75.45,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 75.45,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 71.28,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 71.28,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 67.1,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 67.1,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 62.93,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 62.93,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 58.76,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 58.76,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 54.59,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 54.59,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 50.42,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 50.42,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 46.25,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 46.25,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 42.08,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 42.08,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 48.55,
    y: 37.91,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 37.91,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 42.08,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 46.25,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 50.42,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 54.59,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 58.76,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 62.93,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 67.1,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 71.27,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 75.45,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 79.61,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 83.79,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 87.96,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 43.53,
    y: 92.13,
    width: 1.97,
    height: 2.46
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 46.03,
    y: 37.91,
    width: 1.97,
    height: 2.46
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m147.2,53.63h-20.09v3.64h-2.06v42.89h1.59s11.29,0,11.29,0h0s1.58,0,1.58,0h1.25s6.96,0,6.96,0h0s.84,0,.84,0v-42.89h-1.36v-3.64Zm-32.5,13.87h-4.01v-1.91h-10.92v1.91h-3.59v3.08h-4.92v29.57h25.01v-29.57h-1.56v-3.08Zm-72.86-31.69h-12.27v39.23H10.65v25.11h40.87V35.82h-9.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-2--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 27.57,
    y: 62.91,
    width: 31.92,
    height: 37.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 53.5,
    y: 66.47,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 54.82,
    y: 65.21,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 52.19,
    y: 65.21,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 31.2,
    y: 65.21,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 29.89,
    y: 92.21,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 54.82,
    y: 93.47,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 49.7,
    y: 76.99,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 48.39,
    y: 78.24,
    width: 2.35,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 26.75,
    y: 74.34,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 26.75,
    y: 74.34,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 26.75,
    y: 69.05,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 26.75,
    y: 69.05,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 27.57,
    y: 70.06,
    width: 31.92,
    height: 4.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 26.75,
    y: 62.41,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 26.75,
    y: 62.41,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 26.75,
    y: 99.32,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 26.75,
    y: 99.32,
    width: 33.56,
    height: 1.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 50.34,
    y: 76.22,
    width: 7.97,
    height: 4.51
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "58.31 76.22 58.31 78.37 55.95 80.74 53.3 80.74 57.81 76.22 58.31 76.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "55.25 76.22 50.74 80.74 50.34 80.74 50.34 80.57 54.69 76.22 55.25 76.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "53.28 76.22 50.34 79.16 50.34 78.07 52.19 76.22 53.28 76.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "58.31 79.13 58.31 80.23 57.81 80.74 56.71 80.74 58.31 79.13"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 50.34,
    y: 81.69,
    width: 7.97,
    height: 18.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 51.53,
    y: 82.91,
    width: 5.6,
    height: 9.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 82.91,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 83.2,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 83.49,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 83.78,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 84.07,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 84.36,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 84.65,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 84.94,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 85.24,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 85.53,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 85.82,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 86.11,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 86.4,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 86.69,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 86.99,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 87.28,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 87.57,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 87.86,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 88.15,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 88.44,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 88.73,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 89.03,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 51.53,
    y: 89.32,
    width: 5.6,
    height: 0.21
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.13 82.91 57.13 84.01 51.53 89.61 51.53 86.96 55.58 82.91 57.13 82.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.13 88.69 57.13 91.34 56.41 92.06 53.76 92.06 57.13 88.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.13 87.53 57.13 88.09 53.16 92.06 52.6 92.06 57.13 87.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "55.02 82.91 51.53 86.39 51.53 85.29 53.92 82.91 55.02 82.91"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 52.03,
    y: 93.09,
    width: 4.2,
    height: 0.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 57.29,
    y: 92.5,
    width: 0.49,
    height: 1.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m51.53,98.77c-.02-.27-.03-.54-.04-.8s-.02-.54-.03-.81c-.01-.54-.02-1.07-.03-1.61v-.09h2.62c.42,0,.84.02,1.26.03.21,0,.42.01.63.02s.42.02.63.03l-.63.03c-.21,0-.42.02-.63.02-.42.01-.84.02-1.26.03s-.84.01-1.26.01h-1.26l.09-.09c0,.54-.01,1.07-.03,1.61,0,.27-.02.54-.03.81s-.02.54-.04.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m57.13,95.55c.02.27.03.54.04.81s.02.54.03.8c.01.54.02,1.07.03,1.61v.09h-2.65c-.43,0-.85-.02-1.28-.03l-.64-.03c-.21,0-.42-.02-.64-.03l.64-.03c.21,0,.43-.02.64-.02.42-.01.85-.02,1.28-.03s.85-.01,1.28-.01h1.28l-.09.09c0-.54.01-1.07.03-1.61,0-.27.01-.54.03-.8s.02-.55.04-.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m52.25,98.16c-.03-.33-.05-.67-.06-1,0-.17-.01-.33-.02-.5s0-.33,0-.5v-.09h1.03c.31,0,.62,0,.94.01s.62.01.94.03.62.03.94.06c-.31.03-.62.05-.94.06s-.62.02-.94.03-.62,0-.94,0h-.94l.09-.09c0,.17,0,.33-.01.5s0,.33-.02.5c-.03.33-.04.66-.07,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m56.4,96.16c.03.33.05.67.06,1s.02.67.03,1v.09h-1.99c-.32,0-.63-.02-.95-.03s-.63-.03-.95-.06c.32-.03.63-.05.95-.06.32-.01.63-.02.95-.03.32,0,.63,0,.95-.01s.63,0,.95,0l-.09.09c0-.34,0-.67.03-1,.01-.33.03-.66.06-.99Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.93,
    y: 75.71,
    width: 19.8,
    height: 17.91
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 29.42,
    y: 76.22,
    width: 18.81,
    height: 16.89
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48.23 87.66 48.23 90.31 45.43 93.11 42.78 93.11 48.23 87.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "43.29 76.22 29.42 90.1 29.42 87.45 40.64 76.22 43.29 76.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "44.95 76.22 29.42 91.75 29.42 91.19 44.39 76.22 44.95 76.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48.23 83.39 48.23 83.95 39.07 93.11 38.51 93.11 48.23 83.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48.23 91.32 48.23 92.42 47.54 93.11 46.44 93.11 48.23 91.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "38.34 76.22 29.42 85.15 29.42 84.05 37.25 76.22 38.34 76.22"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m29.1,86.66c0,.1-.08.19-.19.19s-.19-.08-.19-.19.08-.19.19-.19h0c.1,0,.19.08.19.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m48.53,86.66c0,.1.08.19.19.19s.19-.08.19-.19-.08-.19-.19-.19h0c-.1,0-.19.08-.19.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.03,97.95c-.02-.27-.03-.54-.04-.81s-.02-.54-.03-.81c-.01-.54-.02-1.07-.03-1.61v-.09h2.62c.42,0,.84.02,1.26.03.21,0,.42.02.63.02l.63.03c-.21.01-.42.02-.63.03s-.42.02-.63.02c-.42.01-.84.02-1.26.03s-.84,0-1.26,0h-1.26l.09-.09c0,.54-.01,1.07-.03,1.61,0,.27-.01.54-.03.81s0,.55-.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34.63,94.73c.02.27.03.54.04.81s.02.54.03.8c.01.54.02,1.07.03,1.61v.09h-1.37c-.43,0-.85,0-1.28-.01s-.85-.01-1.28-.03l-.64-.03-.64-.03c.21-.01.43-.02.64-.03l.64-.03c.43-.01.85-.02,1.28-.03s.85-.01,1.28-.01h1.28l-.09.09c0-.54.01-1.07.03-1.61,0-.27.02-.54.03-.8s.02-.53.04-.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.75,97.34c-.01-.33-.03-.67-.03-1v-1.05h1.92c.31,0,.62,0,.93.01s.63.02.95.03c-.31.01-.62.02-.95.03s-.62.01-.93.01h-1.87l.04-.04v1c-.04.33-.04.67-.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.9,95.34c.01.33.02.67.03,1s.01.67.01,1v.04h-1.94c-.32,0-.63,0-.95-.01s-.63-.01-.95-.03c.32-.01.63-.02.95-.03s.63-.02.95-.02h1.9l-.05.04c0-.33,0-.67.01-1s.02-.67.03-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.75,97.34c-.01-.33-.02-.67-.03-1v-1.05h1.92c.31,0,.62,0,.94.01l.94.03c-.31.01-.63.02-.94.03s-.62.01-.94.01h-1.87l.04-.04v1c-.03.33-.05.67-.06,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.91,95.34c0,.33.02.67.03,1s.01.67.01,1v.04h-1.94c-.32,0-.63,0-.95-.01s-.63-.01-.95-.03c.32-.01.63-.02.95-.03s.63-.02.95-.02h1.9l-.04.04c0-.33,0-.67.01-1s0-.67.03-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.03,97.95c-.02-.27-.03-.54-.04-.81s-.02-.54-.03-.81c-.01-.54-.02-1.07-.03-1.61v-.09h2.62c.42,0,.84.02,1.26.03.21,0,.42.02.63.02l.63.03c-.21.01-.42.02-.63.03s-.42.02-.63.02c-.42.01-.84.02-1.26.03s-.84,0-1.26,0h-1.26l.09-.09c0,.54-.01,1.07-.03,1.61,0,.27-.02.54-.03.81s-.02.55-.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.62,94.73c.02.27.03.54.04.81s.02.54.03.8c.01.54.02,1.07.03,1.61v.09h-1.37c-.42,0-.85,0-1.28-.01s-.85-.01-1.28-.03l-.64-.03c-.21,0-.42-.02-.64-.03.21-.01.42-.02.64-.03l.64-.03c.42-.01.85-.02,1.28-.03s.85-.01,1.28-.01h1.28l-.09.09c0-.54.01-1.07.03-1.61,0-.27.01-.54.03-.8s.04-.53.04-.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.75,97.34c-.01-.33-.02-.67-.03-1v-1.05h1.9c.31,0,.62,0,.95.01s.62.02.94.03c-.31.01-.62.02-.94.03s-.62.01-.95.01h-.92s-.94.01-.94.01l.05-.04v1c-.03.32-.04.65-.06.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.9,95.34c.01.33.02.67.03,1s.01.67.01,1v.04h-1.94c-.32,0-.63,0-.95-.01s-.63-.01-.95-.03c.32-.01.63-.02.95-.03s.63-.02.95-.02h1.9l-.04.04c0-.33,0-.67.01-1s.02-.67.03-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m43.04,97.95c-.02-.27-.03-.54-.04-.81s-.02-.54-.03-.81c-.01-.54-.02-1.07-.03-1.61v-.09h2.62c.42,0,.84.02,1.26.03.21,0,.42.02.63.02l.63.03c-.21.01-.42.02-.63.03s-.42.02-.63.02c-.42.01-.84.02-1.26.03s-.84,0-1.26,0h-1.26l.09-.09c0,.54-.01,1.07-.03,1.61,0,.27-.01.54-.03.81s-.04.55-.04.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.63,94.73c.02.27.03.54.04.81s.02.54.03.8c.01.54.02,1.07.03,1.61v.09h-1.37c-.43,0-.85,0-1.28-.01s-.85-.01-1.28-.03l-.64-.03-.64-.03c.21-.01.43-.02.64-.03l.64-.03c.43-.01.85-.02,1.28-.03s.85-.01,1.28-.01h1.28l-.09.09c0-.54.01-1.07.03-1.61,0-.27.02-.54.03-.8s.02-.53.04-.8Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "26.75 63.42 27.57 63.42 27.57 69.05 26.75 69.05 26.75 70.06 27.57 70.06 27.57 70.06 27.57 74.34 26.75 74.34 26.75 75.35 27.57 75.35 27.57 99.32 26.75 99.32 26.75 100.33 27.57 100.33 50.34 100.33 58.31 100.33 59.49 100.33 60.31 100.33 60.31 99.32 59.49 99.32 59.49 75.35 60.31 75.35 60.31 74.34 59.49 74.34 59.49 70.06 59.49 70.06 60.31 70.06 60.31 69.05 59.49 69.05 59.49 63.42 60.31 63.42 60.31 62.41 26.75 62.41 26.75 63.42"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--store-4--inject-65"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 125.61,
    y: 46.72,
    width: 35.82,
    height: 53.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 155.67,
    y: 68.62,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 157.04,
    y: 67.32,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 154.31,
    y: 67.32,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 149.27,
    y: 54.8,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 150.64,
    y: 56.1,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 127.6,
    y: 67.32,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 127.6,
    y: 93.2,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 126.24,
    y: 91.9,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 157.04,
    y: 93.2,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 149.27,
    y: 77.92,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 147.91,
    y: 79.22,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 128.97,
    y: 48.87,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 127.61,
    y: 50.18,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 138.05,
    y: 50.18,
    width: 2.44,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 124.95,
    y: 75.81,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 124.95,
    y: 70.32,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-83",
    points: "125.61 75.81 125.61 71.36 161.43 71.36 161.43 75.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 124.95,
    y: 53.01,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 124.95,
    y: 45.68,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 124.95,
    y: 99.28,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 124.95,
    y: 99.28,
    width: 37.14,
    height: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 129.34,
    y: 56.29,
    width: 6.62,
    height: 10.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 129.88,
    y: 56.83,
    width: 5.55,
    height: 9.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "135.43 56.83 135.43 57.92 129.88 63.47 129.88 60.84 133.89 56.83 135.43 56.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "135.43 62.56 135.43 65.19 134.72 65.89 132.09 65.89 135.43 62.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "135.43 61.41 135.43 61.96 131.49 65.89 130.94 65.89 135.43 61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-21",
    points: "133.33 56.83 129.88 60.28 129.88 59.2 132.25 56.83 133.33 56.83"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 129.88,
    y: 59.43,
    width: 5.55,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 140.21,
    y: 56.29,
    width: 6.62,
    height: 10.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 140.75,
    y: 56.83,
    width: 5.55,
    height: 9.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "146.29 56.83 146.29 57.92 140.75 63.47 140.75 60.84 144.76 56.83 146.29 56.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "146.29 62.56 146.29 65.19 145.59 65.89 142.96 65.89 146.29 62.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "146.29 61.41 146.29 61.96 142.36 65.89 141.81 65.89 146.29 61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "144.2 56.83 140.75 60.28 140.75 59.2 143.11 56.83 144.2 56.83"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 140.75,
    y: 59.43,
    width: 5.55,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 151.08,
    y: 56.29,
    width: 6.62,
    height: 10.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 151.62,
    y: 56.83,
    width: 5.55,
    height: 9.06
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "157.16 56.83 157.16 57.92 151.62 63.47 151.62 60.84 155.63 56.83 157.16 56.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "157.16 62.56 157.16 65.19 156.45 65.89 153.83 65.89 157.16 62.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "157.16 61.41 157.16 61.96 153.23 65.89 152.68 65.89 157.16 61.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "155.07 56.83 151.62 60.28 151.62 59.2 153.98 56.83 155.07 56.83"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 151.62,
    y: 59.43,
    width: 5.55,
    height: 0.54
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 129.34,
    y: 48.07,
    width: 6.62,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 129.88,
    y: 48.61,
    width: 5.55,
    height: 2.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "135.43 48.61 135.43 49.7 133.92 51.21 131.29 51.21 133.89 48.61 135.43 48.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "133.33 48.61 130.73 51.21 129.88 51.21 129.88 50.98 132.25 48.61 133.33 48.61"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 140.21,
    y: 48.07,
    width: 6.62,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 140.75,
    y: 48.61,
    width: 5.55,
    height: 2.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "146.29 48.61 146.29 49.7 144.79 51.21 142.16 51.21 144.76 48.61 146.29 48.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "144.2 48.61 141.6 51.21 140.75 51.21 140.75 50.98 143.12 48.61 144.2 48.61"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 151.08,
    y: 48.07,
    width: 6.62,
    height: 3.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 151.62,
    y: 48.61,
    width: 5.55,
    height: 2.6
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "157.16 48.61 157.16 49.7 155.66 51.21 153.03 51.21 155.63 48.61 157.16 48.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "155.07 48.61 152.47 51.21 151.62 51.21 151.62 50.98 153.98 48.61 155.07 48.61"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 150.99,
    y: 80.98,
    width: 8.28,
    height: 19.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 152.22,
    y: 82.24,
    width: 5.81,
    height: 15.95
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "158.04 95.13 158.04 97.88 157.73 98.19 154.97 98.19 158.04 95.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "158.04 82.24 158.04 83.18 152.22 88.99 152.22 86.24 156.22 82.24 158.04 82.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "158.04 84.31 158.04 84.89 152.22 90.71 152.22 90.13 158.04 84.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "158.04 90.7 158.04 91.28 152.22 97.09 152.22 96.51 158.04 90.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "153.83 82.24 152.22 83.85 152.22 82.71 152.69 82.24 153.83 82.24"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 158.4,
    y: 92.2,
    width: 0.51,
    height: 1.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 152.22,
    y: 91.66,
    width: 5.81,
    height: 0.53
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 127.78,
    y: 80.98,
    width: 20.55,
    height: 15.61
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 128.29,
    y: 81.51,
    width: 19.53,
    height: 14.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m151.12,85.93c0,.07-.06.13-.14.13-.07,0-.13-.06-.13-.13,0-.07.06-.13.13-.14.07,0,.14.06.14.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m159.12,85.93c0,.07.06.13.14.13.07,0,.13-.06.13-.13,0-.07-.06-.13-.13-.14-.07,0-.14.06-.14.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 128.29,
    y: 81.51,
    width: 19.53,
    height: 14.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "147.82 90.4 147.82 93.15 144.91 96.06 142.15 96.06 147.82 90.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "139.71 81.51 128.29 92.93 128.29 90.18 136.96 81.51 139.71 81.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "141.43 81.51 128.29 94.64 128.29 94.06 140.85 81.51 141.43 81.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "147.82 85.97 147.82 86.55 138.3 96.06 137.72 96.06 147.82 85.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "147.82 94.2 147.82 95.34 147.09 96.06 145.95 96.06 147.82 94.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "134.57 81.51 128.29 87.79 128.29 86.65 133.43 81.51 134.57 81.51"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "124.95 45.68 162.09 45.68 162.09 46.72 161.43 46.72 161.43 53.01 162.09 53.01 162.09 54.05 161.43 54.05 161.43 70.32 162.09 70.32 162.09 71.36 161.43 71.36 161.43 71.36 161.43 75.81 162.09 75.81 162.09 76.86 161.43 76.86 161.43 99.28 162.09 99.28 162.09 100.32 161.43 100.32 161.43 100.33 125.61 100.33 125.61 100.32 124.95 100.32 124.95 99.28 125.61 99.28 125.61 76.86 124.95 76.86 124.95 75.81 125.61 75.81 125.61 71.36 125.61 71.36 124.95 71.36 124.95 70.32 125.61 70.32 125.61 54.05 124.95 54.05 124.95 53.01 125.61 53.01 125.61 46.72 124.95 46.72 124.95 45.68"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m168.07,78.11s6.05,13.44-3.83,13.45c-9.88.01-3.49-13.9-3.49-13.9,0,0-2.29-1,.36-8.51,2.64-7.5,3.83-7.51,4.93-7.51,1.39,0,2.7,3.25,1.75,8.23,0,0,3.48,6.22.28,8.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "163.37 100.49 164.3 80.23 165.28 100.48 163.37 100.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "163.92 88.72 167.51 84.52 164.7 89.28 163.92 88.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m17.56,78.11s6.05,13.44-3.83,13.45c-9.88.01-3.49-13.9-3.49-13.9,0,0-2.29-1,.36-8.51,2.64-7.5,3.83-7.51,4.93-7.51,1.39,0,2.7,3.25,1.75,8.23,0,0,3.48,6.22.28,8.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "12.86 100.49 13.79 80.23 14.77 100.48 12.86 100.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "13.41 88.72 17 84.52 14.19 89.28 13.41 88.72"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m40.35,77.39s-3.11-1.23-5.58,3.07c-2.53,4.41.65,7.31,3.17,5.58,0,0,1.98,4.15,5.93,3.15s4.59-4.15,4.59-4.15c0,0,3.51.24,3.6-2.37s-2.47-4.94-2.47-4.94c0,0-.16-6.52-4.4-6.47-4.25.05-4.83,6.13-4.83,6.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "43.26 100.49 44.13 81.09 45.04 100.49 43.26 100.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "43.86 88.36 41.14 82.94 44.4 87.52 43.86 88.36"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 47.51,
    y: 46.63,
    width: 88.59,
    height: 22.19
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47.51,
    y: 39.85,
    width: 88.59,
    height: 6.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 47.51,
    y: 68.82,
    width: 88.59,
    height: 38.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 94.4,
    y: 52.15,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 133.97,
    y: 52.15,
    width: 2.13,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 96.78,
    y: 49.88,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 131.54,
    y: 49.88,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 92.03,
    y: 49.88,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 107.95,
    y: 64.22,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 78.87,
    y: 65.71,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 49.23,
    y: 65.71,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 47.51,
    y: 63.46,
    width: 3.46,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 124.2,
    y: 64.22,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 105.58,
    y: 61.95,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 66.82,
    y: 49.88,
    width: 4.26,
    height: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 46.02,
    y: 68.82,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 46.02,
    y: 44.81,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 46.02,
    y: 105.68,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 46.02,
    y: 68.82,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 46.02,
    y: 44.81,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 46.02,
    y: 38.68,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 46.02,
    y: 38.68,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 46.02,
    y: 105.68,
    width: 91.56,
    height: 1.82
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 80.22,
    y: 80.69,
    width: 11.53,
    height: 26.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 81.93,
    y: 82.45,
    width: 8.1,
    height: 18.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "90.04 82.45 90.04 84.04 81.93 92.15 81.93 88.31 87.79 82.45 90.04 82.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "90.04 90.82 90.04 94.65 84.08 100.62 81.93 100.62 81.93 98.93 90.04 90.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "90.04 89.13 90.04 89.94 81.93 98.06 81.93 97.25 90.04 89.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "86.98 82.45 81.93 87.49 81.93 85.9 85.39 82.45 86.98 82.45"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 90.55,
    y: 94.68,
    width: 0.56,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 81.93,
    y: 95.55,
    width: 8.1,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 91.85,
    y: 80.69,
    width: 11.53,
    height: 26.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 93.57,
    y: 82.45,
    width: 8.1,
    height: 18.18
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "101.67 82.45 101.67 84.04 93.57 92.15 93.57 88.31 99.43 82.45 101.67 82.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "101.67 90.82 101.67 94.65 95.71 100.62 93.57 100.62 93.57 98.93 101.67 90.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "101.67 89.13 101.67 89.94 93.57 98.06 93.57 97.25 101.67 89.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "98.62 82.45 93.57 87.49 93.57 85.9 97.03 82.45 98.62 82.45"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 92.5,
    y: 94.68,
    width: 0.56,
    height: 3.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 93.57,
    y: 95.55,
    width: 8.1,
    height: 1.29
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 52.85,
    y: 82.46,
    width: 27.37,
    height: 23.23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 51.13,
    y: 74.64,
    width: 1.72,
    height: 31.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 66.27,
    y: 65.55,
    width: 1.72,
    height: 31.99,
    transform: "translate(-14.42 148.67) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 70.64,
    y: 55.13,
    width: 1.72,
    height: 40.72,
    transform: "translate(-4 146.99) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 130.85,
    y: 74.64,
    width: 1.72,
    height: 31.04,
    transform: "translate(263.42 180.32) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 115.72,
    y: 65.55,
    width: 1.72,
    height: 31.99,
    transform: "translate(35.03 198.12) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 111.35,
    y: 55.13,
    width: 1.72,
    height: 40.72,
    transform: "translate(36.71 187.7) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "33.57 114.12 27.8 114.12 68.84 73.08 74.61 73.08 33.57 114.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "42.83 114.12 39.98 114.12 81.02 73.08 83.87 73.08 42.83 114.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "69.97 114.12 67.12 114.12 108.16 73.08 111.01 73.08 69.97 114.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "62.79 114.12 49.58 114.12 90.62 73.08 103.83 73.08 62.79 114.12"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 103.45,
    y: 82.4,
    width: 27.48,
    height: 23.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 52.85,
    y: 76.35,
    width: 78.01,
    height: 4.34
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "84.11 114.12 78.34 114.12 119.38 73.08 125.15 73.08 84.11 114.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.37 114.12 90.52 114.12 131.56 73.08 134.41 73.08 93.37 114.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "120.51 114.12 117.66 114.12 158.7 73.08 161.55 73.08 120.51 114.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "113.33 114.12 100.12 114.12 141.16 73.08 154.37 73.08 113.33 114.12"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-62"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "48.62 99.04 42.85 99.04 83.89 58 89.66 58 48.62 99.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "57.88 99.04 55.03 99.04 96.07 58 98.92 58 57.88 99.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "85.02 99.04 82.17 99.04 123.21 58 126.06 58 85.02 99.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "77.84 99.04 64.63 99.04 105.67 58 118.88 58 77.84 99.04"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "99.2 99.04 93.43 99.04 134.47 58 140.24 58 99.2 99.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "108.45 99.04 105.6 99.04 146.65 58 149.49 58 108.45 99.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "135.59 99.04 132.74 99.04 173.79 58 176.63 58 135.59 99.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "128.41 99.04 115.21 99.04 156.25 58 169.45 58 128.41 99.04"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m70.7,56.96l-1.89,2.02h1.89v.97h-3.53v-.97l1.88-2.02h-1.88v-.97h3.53v.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m71.92,54.27c.45,0,.75.29.75.64s-.3.64-.75.64-.76-.29-.76-.64.3-.64.76-.64Zm.64,5.68h-1.29v-3.96h1.29v3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m77.15,57.01c.16.35.23.76.2,1.22h-2.95c.08.54.4.83.83.83.35,0,.66-.18.76-.58h1.28c-.16,1.01-.99,1.54-2.04,1.54-1.28,0-2.14-.71-2.14-2.05s.85-2.05,2.14-2.05c.94,0,1.6.41,1.91,1.09Zm-1.13.53c-.01-.06-.03-.12-.04-.18-.12-.33-.39-.51-.74-.51-.4,0-.7.24-.81.69h1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m79.17,57.35l1.06-1.37h1.48l-1.56,1.98,1.58,1.98h-1.48l-1.07-1.35v1.35h-1.29v-5.27h1.29v2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m85.71,57.01c.16.35.23.76.2,1.22h-2.95c.08.54.4.83.83.83.35,0,.66-.18.76-.58h1.28c-.16,1.01-.99,1.54-2.04,1.54-1.28,0-2.14-.71-2.14-2.05s.85-2.05,2.14-2.05c.94,0,1.6.41,1.91,1.09Zm-1.13.53c-.01-.06-.03-.12-.04-.18-.12-.33-.39-.51-.74-.51-.4,0-.7.24-.81.69h1.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m88.93,57.07c-.11-.12-.27-.18-.49-.18-.45,0-.75.35-.75.82v2.24h-1.29v-3.96h1.29v.55c.21-.39.62-.62,1.15-.62s.89.13,1.15.39c.29.27.42.69.42,1.23v2.41h-1.29v-2.28c0-.27-.06-.48-.19-.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m93.11,56.89c-.45,0-.76.37-.75.84v2.22h-1.29v-5.27h1.29v1.86c.2-.4.63-.62,1.15-.62.63,0,1.06.21,1.31.61.17.26.26.6.26,1.01v2.41h-1.29v-2.28c0-.52-.23-.78-.68-.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m97.15,58.87c.11.12.27.18.49.18.45,0,.75-.35.75-.82v-2.24h1.29v3.96h-1.29v-.55c-.21.39-.62.62-1.15.62s-.89-.13-1.15-.39c-.29-.27-.43-.69-.43-1.23v-2.41h1.29v2.28c0,.27.06.48.19.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m101,54.27c.45,0,.75.29.75.64s-.3.64-.75.64-.76-.29-.76-.64.3-.64.76-.64Zm.64,5.68h-1.29v-3.96h1.29v3.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m104.18,56.72c-.39,0-.63.14-.62.35.02.24.32.37.86.46,1.21.22,1.7.49,1.7,1.2,0,.83-.81,1.29-1.98,1.28-1.18,0-1.94-.39-1.92-1.3h1.24c-.03.29.26.48.7.48.41,0,.67-.18.64-.41-.03-.26-.54-.38-1.27-.53-.82-.18-1.29-.53-1.29-1.18,0-.77.75-1.15,1.89-1.14,1.06,0,1.89.39,1.87,1.24h-1.24c0-.28-.23-.45-.6-.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 57.38,
    cy: 57.9,
    r: 6.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.13,
    y: 54.01,
    width: 2.48,
    height: 7.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 56.13,
    y: 54.01,
    width: 2.48,
    height: 7.77,
    transform: "translate(-.52 115.28) rotate(-90)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent12Ziekenhuis);
export default __webpack_public_path__ + "static/media/event1.2-ziekenhuis.b7eabd26ef11dcf8aa1af3d7768df77e.svg";
export { ForwardRef as ReactComponent };